import { AgrEnvironment, AgrProcessEnv, parseAgrEnvironment } from '@next/core-lib/environment';

export class Environment extends AgrEnvironment {
  AZURE_MAPS_SUBSCRIPTION_KEY: string;
  PRE_SALES_REBUILD_DONE: boolean;
  FIELD_ADVICE_TEMPLATE_REBUILD_DONE: boolean;

  constructor(env: Environment) {
    super(env);
    this.AZURE_MAPS_SUBSCRIPTION_KEY = env.AZURE_MAPS_SUBSCRIPTION_KEY;
    this.PRE_SALES_REBUILD_DONE = env.PRE_SALES_REBUILD_DONE;
    this.FIELD_ADVICE_TEMPLATE_REBUILD_DONE = env.FIELD_ADVICE_TEMPLATE_REBUILD_DONE;
  }
}

export const parseNextAdminEnvironment = ({
  AZURE_MAPS_SUBSCRIPTION_KEY,
  PRE_SALES_REBUILD_DONE,
  FIELD_ADVICE_TEMPLATE_REBUILD_DONE,
  ...env
}: AgrProcessEnv): Environment => {
  const baseEnv = parseAgrEnvironment(env);
  return new Environment({
    ...baseEnv,
    AZURE_MAPS_SUBSCRIPTION_KEY: AZURE_MAPS_SUBSCRIPTION_KEY ?? '',
    PRE_SALES_REBUILD_DONE: PRE_SALES_REBUILD_DONE === 'true',
    FIELD_ADVICE_TEMPLATE_REBUILD_DONE: FIELD_ADVICE_TEMPLATE_REBUILD_DONE === 'true',
  });
};
